import type { Person } from "@/hooks/api/use-account-persons";
import type { UnifiedTableColumn } from "@/types/table-column";
import type { PersonWithTouchpoints } from "./custom-buying-group-modal";

/**
 * Column definitions for the People table in the custom buying group modal
 */
export const getPersonColumns =
  (): UnifiedTableColumn<PersonWithTouchpoints>[] => {
    return [
      {
        key: "fullName",
        title: "Person",
        sortable: true,
        filterable: true,
        filterType: "text",
      },
      {
        key: "email_address",
        title: "Email",
        sortable: true,
        filterable: true,
        filterType: "text",
      },
      {
        key: "job_title",
        title: "Title",
        sortable: true,
        filterable: true,
        filterType: "text",
      },
      {
        key: "inboundTouchpoints",
        title: "Engagements",
        sortable: true,
        filterable: true,
        filterType: "number",
      },
      {
        key: "outboundTouchpoints",
        title: "Bids",
        sortable: true,
        filterable: true,
        filterType: "number",
      },
    ];
  };

/**
 * Factory function to create a unique key extractor for persons
 */
export const personKeyExtractor = (person: Person): string => person.id;
